/**
 * Design tokens, lifted verbatim from the approved mock
 * «Dashboard A Editorial» (Claude Design project «Редизайн Liquorice.tech»).
 * Do not invent new values here — if a colour is needed, it exists in the mock.
 */
export const C = {
  bg: '#FFFFFF',
  text: '#0A0A0A',
  accent: '#1449E0',
  accentHover: '#1F3080',
  /** accent at 20% — used for the underline under interactive labels */
  accentTint: '#C8D4F6',
  /** accent wash — selected table row */
  accentWash: '#F1F4FD',

  muted: '#6E6E6E',
  muted2: '#7A7A7A',
  faint: '#C0C0C0',

  border: '#E2E2E2',
  rule: '#F0F0F0',
  ruleStrong: '#D6D6D6',
  panel: '#FAFAFB',
  rowHover: '#F7F8FA',
  skipWash: '#FCFAF5',
  track: '#ECECEC',

  pos: '#0B6B3A',
  neg: '#D14343',
  /** «упёрлись», not «сломалось» — deliberately distinct from neg */
  warn: '#8A5A00',
  /** burst / tail bars on the histograms */
  warnBar: '#E8A33D',
  /** calm bars on the histograms */
  calmBar: '#C8D4F6',

  /**
   * Расширение палитры макета: у Uniswap должен быть свой тон. Синий занят
   * нашей котировкой, серый — книгой Binance, и пунктир того же цвета при
   * такой плотности не читается.
   */
  uni: '#7B5EA7',
  /** заливка между нашими бидом и аском — это наш спред */
  ourFill: 'rgba(20, 73, 224, 0.10)',
} as const

export const FONT = 'Archivo, sans-serif'

/** Uppercase, letter-spaced label used above every block. */
export const label = (color: string = C.muted2): React.CSSProperties => ({
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '.16em',
  textTransform: 'uppercase',
  color,
})

/** Small uppercase column head inside tables. */
export const colHead: React.CSSProperties = {
  fontSize: 12,
  letterSpacing: '.12em',
  textTransform: 'uppercase',
  color: C.muted,
}

/** The blue 4px rule that opens a major section. */
export const sectionRule: React.CSSProperties = {
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: 12,
  rowGap: 6,
  flexWrap: 'wrap',
  borderBottom: `4px solid ${C.accent}`,
}

/** Clickable text affordance — never a button, always an underlined caption. */
export const action: React.CSSProperties = {
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: '.1em',
  textTransform: 'uppercase',
  color: C.accent,
  borderBottom: `1px solid ${C.accentTint}`,
  whiteSpace: 'nowrap',
  userSelect: 'none',
}
